import { useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { Check, RotateCcw, X } from "lucide-react";
import { RENKLER, KIRMIZI_MESAJ, kirmiziMi, renkUygula } from "../../lib/taskColors";

// Geciken görev işareti: SABİT kırmızı sol şerit + "GECİKTİ" rozeti (kart renginden bağımsız).
export const GecikmeIsareti = ({ testId, satir = false }) => (
  <>
    <span aria-hidden data-testid={testId ? `${testId}-serit` : undefined}
      className="pointer-events-none absolute left-0 top-0 bottom-0 w-[4px] rounded-l z-[5]" style={{ background: "#ef4444" }} />
    <span data-testid={testId} role="status"
      className={`pointer-events-none absolute left-1/2 -translate-x-1/2 z-[6] px-1.5 leading-[14px] text-[9px] font-bold tracking-wider rounded ${satir ? "-top-[7px]" : "top-0 rounded-t-none"}`}
      style={{ background: "#dc2626", color: "#ffffff" }}>
      SÜRESİ GEÇTİ
    </span>
  </>
);

// Renk seçici: hedefler = [{task_id, sub_id?}] (tekli veya toplu).
export const RenkSecici = ({ hedefler, mevcut, onClose, testPrefix = "renk" }) => {
  const [ozel, setOzel] = useState(mevcut && mevcut.startsWith("#") ? mevcut : "#3b82f6");
  const [mesgul, setMesgul] = useState(false);
  const sec = async (renk) => {
    if (renk && renk.startsWith("#") && kirmiziMi(renk)) { toast.error(KIRMIZI_MESAJ); return; }
    setMesgul(true);
    try {
      await renkUygula(hedefler, renk);
      toast.success(hedefler.length > 1 ? `${hedefler.length} öğenin rengi değiştirildi` : renk ? "Renk değiştirildi" : "Varsayılan renge dönüldü");
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Renk değiştirilemedi");
      setMesgul(false);
    }
  };
  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60" data-testid={`${testPrefix}-secici`}
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="w-[320px] max-w-[94vw] rounded-lg border border-sertex-cyan/40 bg-sertex-surface p-3 shadow-2xl">
        <div className="flex items-center justify-between mb-2">
          <span className="hud-text text-sertex-cyan">Rengini değiştir{hedefler.length > 1 ? ` · ${hedefler.length} öğe` : ""}</span>
          <button onClick={onClose} data-testid={`${testPrefix}-kapat`} aria-label="Kapat" className="text-sertex-textMuted hover:text-sertex-cyan"><X className="h-4 w-4" /></button>
        </div>
        <div className="grid grid-cols-4 gap-1.5">
          {RENKLER.map((r) => (
            <button key={r.key} disabled={mesgul} onClick={() => sec(r.key === "mavi" ? null : r.key)} data-testid={`${testPrefix}-${r.key}`} title={r.ad}
              className="flex flex-col items-center gap-0.5 rounded border border-sertex-cyan/15 p-1 hover:border-sertex-cyan/60 disabled:opacity-50">
              <span className="h-5 w-5 rounded-full border border-white/20 flex items-center justify-center" style={{ background: r.hex }}>
                {(mevcut || "mavi") === r.key && <Check className="h-3 w-3 text-black" />}
              </span>
              <span className="text-[10px] text-sertex-textSecondary truncate max-w-full">{r.ad}</span>
            </button>
          ))}
        </div>
        <div className="mt-2 flex items-center gap-2">
          <span className="text-[11px] text-sertex-textSecondary">Özel renk</span>
          <input type="color" value={ozel} onChange={(e) => setOzel(e.target.value)} data-testid={`${testPrefix}-ozel-girdi`} className="h-7 w-10 bg-transparent" />
          <button disabled={mesgul} onClick={() => sec(ozel)} data-testid={`${testPrefix}-ozel-uygula`}
            className="hud-text px-2 py-1 rounded border border-sertex-cyan/50 text-sertex-cyan hover:bg-sertex-cyan/10">Uygula</button>
        </div>
        <button disabled={mesgul} onClick={() => sec(null)} data-testid={`${testPrefix}-varsayilan`}
          className="mt-2 w-full hud-text px-2 py-1 rounded border border-sertex-textMuted/40 text-sertex-textSecondary hover:text-sertex-cyan flex items-center justify-center gap-1">
          <RotateCcw className="h-3 w-3" /> Varsayılan renge dön
        </button>
      </div>
    </div>,
    document.body,
  );
};
